export const TIER_NAMES: Record<number, string> = {
  // Legacy tiers (0-4)
  0: "Free",
  1: "Basic",
  2: "Growth",
  3: "Professional",
  4: "Enterprise",
  // New monthly tiers (5-8)
  5: "Builder",
  6: "Growth",
  7: "Professional",
  8: "Enterprise",
  // New annual tiers (9-12)
  9: "Builder",
  10: "Growth",
  11: "Professional",
  12: "Enterprise",
};

export const TIER_CREDITS: Record<number, number> = {
  // Legacy tiers (0-4)
  0: 500,
  1: 75_000,
  2: 225_000,
  3: 675_000,
  4: 5_000_000,
  // New monthly tiers (5-8)
  5: 50_000,
  6: 450_000,
  7: 1_500_000,
  8: 5_000_000,
  // New annual tiers (9-12) — same credits as monthly counterparts
  9: 50_000,
  10: 450_000,
  11: 1_500_000,
  12: 5_000_000,
};

export const TIER_PRICES_MONTHLY: Record<number, number> = {
  // Legacy tiers
  0: 0,
  1: 25,
  2: 65,
  3: 150,
  4: 300,
  // New monthly tiers
  5: 30,
  6: 80,
  7: 225,
  8: 500,
  // New annual tiers (monthly equivalent)
  9: 24,
  10: 64,
  11: 180,
  12: 400,
};
